import { memo, useMemo } from 'react';

import { Typography } from '@mui/material';

import { parseIntervalToMs, formatTime, formatIntervalToReadable } from 'src/utils/breakReason';
import { useElapsedTime } from 'src/contexts/GlobalTimerContext';

/**
 * Timer otimizado que usa o GlobalTimerContext
 * Em vez de cada instância ter seu próprio setInterval,
 * todas usam um único timer global sincronizado.
 * 
 * Isso evita congelamento quando:
 * - A aba está em background e volta ao foco
 * - Muitas linhas na tabela (cada uma teria 2 timers)
 */
function BreakReasonOnlyTimer(props) {
	const { isOverflowTime, breakWorkData } = props;

	const startdateValue = breakWorkData?.startdateOriginal || breakWorkData?.startdate;
	const breaklimitValue = breakWorkData?.breaklimitOriginal || breakWorkData?.breaklimit;

	// Usa o timer global em vez de setInterval próprio
	const { elapsed: elapsedTime } = useElapsedTime(startdateValue);

	const limitTimeMs = useMemo(() => {
		return parseIntervalToMs(breaklimitValue);
	}, [breaklimitValue]);

	const exceededTime = elapsedTime > limitTimeMs ? elapsedTime - limitTimeMs : 0;

	if (isOverflowTime) {
		if (exceededTime <= 0) {
			return <Typography>Não excedeu</Typography>;
		}
		
		return (
			<Typography color={"error"} style={{ fontWeight: 'bold' }}>
				{formatIntervalToReadable(formatTime(exceededTime))}
			</Typography>
		);
	}

	return (
		<Typography>
			{formatTime(elapsedTime)}
		</Typography>
	);
}

// Memoiza para evitar re-renders desnecessários quando a tabela atualiza
export default memo(BreakReasonOnlyTimer, (prevProps, nextProps) => {
	// Só re-renderiza se o breakWorkData.id mudar ou as props relevantes mudarem
	return (
		prevProps.breakWorkData?.id === nextProps.breakWorkData?.id &&
		prevProps.breakWorkData?.startdateOriginal === nextProps.breakWorkData?.startdateOriginal &&
		prevProps.breakWorkData?.startdate === nextProps.breakWorkData?.startdate &&
		prevProps.breakWorkData?.breaklimitOriginal === nextProps.breakWorkData?.breaklimitOriginal &&
		prevProps.breakWorkData?.breaklimit === nextProps.breakWorkData?.breaklimit &&
		prevProps.isOverflowTime === nextProps.isOverflowTime
	);
});